module.exports = __webpack_public_path__ + "static/img/sight.b8548a5.png";